export default [
  { iso3166: 'US', code: '1', country_name: 'United States' },
  { iso3166: 'AU', code: '61', country_name: 'Australia' },
  { iso3166: 'FR', code: '33', country_name: 'France' },
  { iso3166: 'GB', code: '44', country_name: 'United Kingdom' },
  { iso3166: 'MD', code: '373', country_name: 'Moldova' },
];
